// extracted by mini-css-extract-plugin
module.exports = {"projects":"projects_projects__2zp3x","projectsWrapper":"projects_projectsWrapper__3BmRf"};